// De geleide eerste minuut: één opdracht tegelijk voor wie nog nooit een shift heeft gespeeld.
// Pure logica: het spel geeft de situatie door, deze functie zegt wat de speler nu moet doen.

import { t } from '../i18n';

export const GUIDE_STEPS = 3;

export interface GuideSituation {
  /** Aangeboden orders die nog niet zijn aangenomen */
  offers: number;
  /** Aangenomen, nog niet ingeladen */
  accepted: number;
  /** In de bak */
  loaded: number;
  /** Scooter dichtbij de bakkerij of de klant */
  nearBakery: boolean;
  nearCustomer: boolean;
  touch: boolean;
}

export interface GuideStep {
  n: number;
  of: number;
  text: string;
}

/** De opdracht van dit moment, of null als er niets te zeggen valt (bijvoorbeeld wachten op een bestelling). */
export function guideStep(s: GuideSituation): GuideStep | null {
  if (s.loaded > 0) {
    return {
      n: 3,
      of: GUIDE_STEPS,
      text: s.nearCustomer ? t('guide.deliverNear') : t('guide.deliver'),
    };
  }
  if (s.accepted > 0) {
    return {
      n: 2,
      of: GUIDE_STEPS,
      text: s.nearBakery ? t('guide.loadNear') : t('guide.load'),
    };
  }
  if (s.offers > 0) {
    return { n: 1, of: GUIDE_STEPS, text: s.touch ? t('guide.acceptTouch') : t('guide.acceptKey') };
  }
  return null;
}
